(() => {
  if (window.nordsignCategoryModel) return;
  window.nordsignCategoryModel = (snapshot, liveRows = []) => {
    const live = new Map(liveRows.map(row => [row.key, row]));
    const records = snapshot.map(row => live.has(row.key) ? {...row, ...live.get(row.key), url: row.url} : row);
    const map = new Map(records.map(row => [row.key, row]));
    const valid = row => {
      const seen = new Set();
      while (row) {
        if (seen.has(row.key) || row.active !== true) return false;
        seen.add(row.key);
        if (row.parent === 'root') return true;
        row = map.get(row.parent);
      }
      return false;
    };
    const allowed = new Set();
    for (const row of records) {
      if (!/^\/collections\/[a-z0-9-]+$/.test(row.url) || !valid(row)) continue;
      let current = row;
      while (current) {
        allowed.add(current.key);
        current = map.get(current.parent);
      }
    }
    const rows = records.filter(row => allowed.has(row.key));
    return {
      records,
      rows,
      children: key => rows.filter(row => row.parent === key).sort((a, b) => Number(a.order) - Number(b.order) || a.key.localeCompare(b.key, undefined, {numeric: true})),
      source: rows.length && rows.every(row => row.source === 'live') ? 'live' : rows.some(row => row.source === 'live') ? 'mixed' : 'snapshot'
    };
  };
})();
